<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" :overlay="false" scrollable fullscreen>
    <v-card tile flat>
      <v-toolbar dark color="primary">
        <v-app-bar-nav-icon><v-icon>fa-coins</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Add a new funder</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0" style="height: 100vh">
        <v-stepper vertical v-model="step">
          <v-stepper-step step="1" :complete="step > 1" editable class="ma-0">
            Funder Details
            <small>The business details of the funder</small>
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card flat tile class="ma-0 mb-5">
              <v-card-text class="pa-0">
                <v-form lazy-validation>
                  <v-container fluid grid-list-md class="pa-0">
                    <v-layout wrap>
                      <v-flex xs4>
                        <v-layout wrap>
                          <v-flex xs12 sm6>
                            <v-text-field label="Funder name" v-model="funder.name" required></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field label="Phone" v-model="funder.phone"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <image-upload :url.sync="funder.logo" :path="'funder-images'"></image-upload>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field label="Address Line 1" v-model="funder.address_1" required></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field label="Address Line 2" v-model="funder.address_2"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field label="Address Line 3" v-model="funder.address_3"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field label="Address Line 4" v-model="funder.address_4"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field label="Address Line 5" v-model="funder.address_5"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field label="Post Code" v-model="funder.post_code" required></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field
                              label="Registered Company Name"
                              v-model="funder.registered_company_name"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field
                              label="Registered Company Number"
                              v-model="funder.registered_company_number"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-select
                              :items="terms"
                              item-text="name"
                              item-value="id"
                              v-model="funder.terms"
                              hide-selected
                              placeholder="BBB Provider Term"
                              dense
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field
                              label="BBB reference"
                              v-model="funder.bbb_id"
                              :disabled="funder.terms === 'No DB referrals' || null"
                              :rules="bbbRefRules"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
            <v-btn color="accent" @click.native="step = 2" :disabled="stepOneInvalid">Continue</v-btn>
          </v-stepper-content>

          <v-stepper-step step="2" :complete="step > 2" editable class="ma-0">
            Product Details
            <small>The product details of the funder</small>
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-card flat tile class="ma-0 mb-5">
              <v-card-text class="pa-0">
                <v-form lazy-validation>
                  <v-container fluid grid-list-md class="pa-0">
                    <v-layout wrap>
                      <v-flex xs4>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field label="Product name" v-model="funder.product.name" required></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              auto-grow
                              counter
                              max="160"
                              label="Description"
                              v-model="funder.product.description"
                            ></v-textarea>
                          </v-flex>
                          <v-flex xs12>
                            <v-select
                              label="Journey"
                              v-model="funder.product.journey_id"
                              :items="journeys"
                              item-text="name"
                              item-value="id"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-select
                              label="Product type"
                              v-model="funder.product.product_type_id"
                              :items="ProductTypes"
                              item-text="name"
                              item-value="id"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field label="Traceable URL" v-model="funder.product.traceable_url"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
            <v-btn color="accent" @click.native="step = 3" :disabled="stepTwoInvalid">Continue</v-btn>
          </v-stepper-content>
          <v-stepper-step step="3" :complete="step > 3" editable :rules="[() => !RegistrationEmailExists]">
            User
            <small v-if="RegistrationEmailExists">Email address is already registered</small>
            <small v-else>The primary user for the account</small>
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-card flat tile class="ma-0 mb-5">
              <v-card-text class="pa-0">
                <v-form lazy-validation>
                  <v-container fluid grid-list-md class="pa-0">
                    <v-layout wrap>
                      <v-flex xs4>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field label="First name" v-model="funder.user.firstName" required></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field label="Last name" v-model="funder.user.lastName" required></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              label="Email"
                              v-model="verifiedEmail"
                              :rules="emailRules"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field label="Phone" v-model="funder.user.phone" required></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
            <v-btn color="accent" @click.native="register" :disabled="stepThreeInvalid">Register</v-btn>
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import ImageUpload from '../Partners/ImageUpload';
import { emailRegex, emailRules } from '@/utils/validators';

const funderDefaults = {
  name: null,
  logo: null,
  phone: null,
  address_1: null,
  address_2: null,
  address_3: null,
  address_4: null,
  address_5: null,
  post_code: null,
  registered_company_name: null,
  registered_company_number: null,
  terms: null,
  bbb_id: null,
  product: {
    name: null,
    description: null,
    product_type_id: null,
    journey_id: null,
    traceable_url: null
  },
  user: {
    firstName: null,
    lastName: null,
    email: null,
    phone: null
  }
};

export default {
  name: 'new-funder-dialog',
  components: { ImageUpload },
  props: ['show'],
  data: () => ({
    step: 1,
    funder: Object.assign({}, funderDefaults),
    emailRules,
    terms: ['Standard Terms - all referrals', 'No DB referrals', 'Standard Terms - DB referrals only']
  }),
  computed: {
    ...mapGetters(['ProductTypes', 'RegistrationEmailExists', 'JourneyTypes']),
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    },
    stepOneInvalid: function() {
      return _.isNull(this.funder.name);
    },
    stepTwoInvalid: function() {
      return (
        _.isNull(this.funder.product.name) ||
        _.isNull(this.funder.product.product_type_id) ||
        _.isNull(this.funder.product.journey_id)
      );
    },
    stepThreeInvalid: function() {
      return (
        this.RegistrationEmailExists ||
        _.isNull(this.funder.user.firstName) ||
        _.isNull(this.funder.user.lastName) ||
        _.isNull(this.verifiedEmail) ||
        !emailRegex.test(this.verifiedEmail)
      );
    },
    verifiedEmail: {
      get() {
        return this.funder.user.email;
      },
      set: _.debounce(function(email) {
        this.funder.user.email = email;
        this.verifyRegistrationEmail(email);
      }, 500)
    },
    journeys: function() {
      return _.isNull(this.JourneyTypes[0].id) ? [] : this.JourneyTypes[1].journeys;
    },
    bbbRefRules() {
      return this.funder.terms !== 'No DB referrals' ? [v => !!v || 'The BBB ref is required'] : [];
    }
  },
  methods: {
    ...mapActions(['registerFunder', 'verifyRegistrationEmail', 'getJourneyTypes']),
    clearRegistration() {
      this.funder = Object.assign({}, funderDefaults);
    },
    register() {
      this.registerFunder(this.funder).then(this.closeDialog());
    },
    closeDialog() {
      this.clearRegistration();
      this.dialog = false;
    },
    startCase: function(str) {
      str = _.lowerCase(str);
      return _.startCase(str);
    },
    isDefined: function(value) {
      return _.isUndefined(value) === false;
    },
    isFilled: function(value) {
      return !_.isEmpty(value);
    }
  },
  mounted() {
    if (_.isNull(this.JourneyTypes[0].id)) {
      this.getJourneyTypes();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
